/**
 * Mirvac Worktech Campaign
 * Author: Charles Harwood <charles@guerrilla.com.au>
 * Copyright 2018 Guerrilla, Mirvac O&I.
 * @preserve
 */


/* Array.find polyfill */
/* eslint-disable */
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function (predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      const o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      const len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      const thisArg = arguments[1];

      // 5. Let k be 0.
      let k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        const kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}
/* eslint-enable */

/* eslint-env browser, jquery */
/* global IN */

(function($) {

  /**
   * Test if the user's device is running iOS,
   * so we can hide the LinkedIn auth CTA as it is incompatible.
   *
   * @returns {Boolean} `true` if device is running iOS
   */
  function isiOS() {

    const iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ];

    if (navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Test if the user's device is running IE11 on Windows 7,
   * so we can hide the LinkedIn auth CTA as it is incompatible.
   *
   * @returns {Boolean} `true` if device is running IE11 on Windows 7.
   */
  function isIE() {
    const UA = window.navigator.userAgent;
    const msie = UA.indexOf('MSIE') > 0;
    const ie11 = UA.indexOf('Trident/7.0') > 0;

    if (ie11 || msie) {
      return true;
    }

    return false;
  }

  if (isiOS() || isIE()) {
    $('.btn-linkedin').hide();
    $('.mv-header__aside__ctas > span').hide();
  }

  /* Global jQuery scripts - CH */

  const $blankLink = $('a[href="#"]');

  $blankLink.click((event) => event.preventDefault());

  const $scrollButton = $('.mv-main__content .btn-link');

  $scrollButton.click(() => {
    const $target = $('.mv-header__aside').offset().top;

    $('html, body').animate({
      scrollTop: $target
    }, 500);

    if ($('.mv-form #tfa_3590416182990').length) {
      $('.mv-form #tfa_3590416182990').focus();
    }
  });

  // Handle custom trigger for API call.
  $('.btn-linkedin').click((event) => {
    event.preventDefault();

    IN.User.authorize(onLinkedInLoad); // eslint-disable-line
  });

  // Handle clicks on regular primary btn.
  $('.btn-register').click((event) => {
    event.preventDefault();

    const $loginWrapper = $('.mv-header__aside--initial');
    const $formWrapper = $('.mv-header__aside--form');
    // Reveal form.
    $loginWrapper.addClass('d-none');
    $formWrapper.removeClass('d-none');
    $formWrapper.find('#tfa_3590416182990').focus();
  });

  // Handle clicks on 'back' button.
  $('.btn-back').click((event) => {
    event.preventDefault();

    const $loginWrapper = $('.mv-header__aside--initial');
    const $formWrapper = $('.mv-header__aside--form');
    // Reveal form.
    $loginWrapper.removeClass('d-none');
    $formWrapper.addClass('d-none');
  });

  // Handle form submissions.
  $('.mv-form').submit((event) => {
    event.preventDefault();
    // Store a key:pair in localStorage so we know they've submitted the form.
    localStorage.setItem('formSubmitted', 'true');
    // Continue with default form submission.
    $('.mv-form').unbind('submit')
      .submit();
  });

}(jQuery));

/* LinkedIn Auth stuff */
/* eslint-disable no-implicit-globals */

// Set up an event listener to make an API call once auth is complete.
function onLinkedInLoad() { // eslint-disable-line no-unused-vars
  IN.Event.on(IN, 'auth', getProfileData); // eslint-disable-line no-use-before-define
}

// Handle the successful returnfrom the API call.
function onLinkedInSuccess(data) {
  const firstName = data.firstName;
  const lastName = data.lastName;
  const emailAddress = data.emailAddress;
  let companyName, jobTitle;

  if (data.positions.values && data.positions.values.length) {
    const currentPosition = data.positions.values.find((job) => job.isCurrent === true);
    companyName = currentPosition.company.name;
    jobTitle = currentPosition.title;
  }

  // Reveal form.
  const $loginWrapper = $('.mv-header__aside--initial');
  const $formWrapper = $('.mv-header__aside--form');
  if (data) {
    $loginWrapper.addClass('d-none');
    $formWrapper.removeClass('d-none');
    $formWrapper.find('#tfa_3590416182990').val(firstName);
    $formWrapper.find('#tfa_3590416182991').val(lastName);
    $formWrapper.find('#tfa_3590416182993').val(emailAddress);
    $formWrapper.find('#tfa_3590416183356').val(companyName);
    $formWrapper.find('#tfa_3590416183254').val(jobTitle);
    $formWrapper.find('#tfa_3590416182994').focus();
  }
}

// Handle an error response from the API call.
function onLinkedInError(error) {
  console.error(error); // eslint-disable-line no-console
}

// Use the API call wrapper to request the member's basic profile data.
function getProfileData() {
  IN.API.Raw('/people/~:(first-name,last-name,email-address,positions)').result(onLinkedInSuccess)
    .error(onLinkedInError);
}
